<script setup lang="ts">
import ManageChildrenView from '../../views/ManageChildrenView/ManageChildrenView.vue';
import BPage from 'src/shared/components/base/BPage/BPage.vue';
import { useGlobalStore } from 'src/stores/global';

const globalStore = useGlobalStore();
globalStore.showBreadcrumbs = false;
</script>

<template>
  <BPage class="bg-dark">
    <div class="col">
      <ManageChildrenView />
    </div>
  </BPage>
</template>
